export default __webpack_public_path__ + "static/media/mango.a0406254.webp";